module.exports = __webpack_public_path__ + "static/media/slackIcon.7e488af6.svg";